import { lazy } from "react";
import { Navigate } from "react-router-dom";
import EmojiTransportationIcon from "@mui/icons-material/EmojiTransportation";

const VendorRoleList = lazy(() => import("../vendorRoleList"));
const Role = lazy(() => import("../role"));

const vendorRoleRoute = {
  icon: EmojiTransportationIcon,
  name: "Vendor Management",
  link: "/vendor-management",
  after: "Vendor",
  path: "vendor-management",
  index: 3,
  element: "",
  children: [
    {
      path: "vendor-roles",
      element: <VendorRoleList />,
      name: "Vendor Roles",
      link: "/vendor-management/vendor-roles",
      icon: EmojiTransportationIcon,
      index: 1,
    },
    {
      path: "vendor-roles/:id",
      element: <Role />,
    },
    {
      path: "",
      element: <Navigate to="vendor-roles" replace />,
    },
  ],
};
export default vendorRoleRoute;
